import { ReactNode } from "react";

interface TitleProps {
  className?: string;
  children: ReactNode;
}

export default function Title({ children, className }: TitleProps) {
  return (
    <div className={className || "wish-border-bottom flex h-12"}>
      <div className="H6 m-auto mx-auto max-w-sm" data-testid="title">
        {children}
      </div>
    </div>
  );
}
